export const importFromCsv = {
  title: '顧客のCSVインポート',
  importSuccessfully: '顧客を正常にインポートしました！',
  importFailed: '顧客のインポートに失敗しました！',
}
